import { createAsyncThunk } from '@reduxjs/toolkit';

import { setNavReady, setNavItem } from '../init';
import { aflApi } from '../../api/afl-api';
import { changeSeason } from '.';

export const changeCompetition = createAsyncThunk(
    'nav/changeCompetition',
    async (payload, { dispatch, getState }) => {
        dispatch(setNavReady(false));

        const { competition, round, removeFinals } = payload;

        if (!competition?.id || Number.isNaN(competition.id)) {
            console.warn('changeCompetition aborted: No valid ID provided');
            return;
        }

        const { data: compData } = await dispatch(
            aflApi.endpoints.getCompetitions.initiate()
        );

        const foundComp = compData.find(
            (item) => item.id === Number.parseInt(competition.id)
        );

        // If initial round hasn't been set in the store, set it now.
        const state = getState().competitionNavV2;
        // Set 'competition' nav item in the state
        if (state.competition.initialItemId) {
            dispatch(
                setNavItem({
                    navItem: 'competition',
                    value: {
                        ...state.competition,
                        ...(foundComp || competition)
                    }
                })
            );
        } else {
            dispatch(
                setNavItem({
                    navItem: 'competition',
                    value: {
                        ...(foundComp || competition),
                        initialItemId: foundComp?.id || competition.id
                    }
                })
            );
        }

        // Get comp seasons for the selected competition
        const { data: seasons } = await dispatch(
            aflApi.endpoints.getCompSeasons.initiate({
                competitionId: foundComp ? foundComp?.id : competition.id
            })
        );

        // Set 'seasons' nav item in the state
        dispatch(setNavItem({ navItem: 'seasons', value: seasons }));

        const selectedSeason =
            seasons.find((item) => item.id === payload.season?.id) ||
            seasons[0];

        // Dispatch changeSeason thunk
        await dispatch(
            changeSeason({
                season: selectedSeason,
                round,
                removeFinals
            })
        );
    }
);
